import { render, staticRenderFns } from "./GlobalErrorWarning.vue?vue&type=template&id=7b851b86&"
import script from "./GlobalErrorWarning.vue?vue&type=script&lang=js&"
export * from "./GlobalErrorWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports